module.exports = __webpack_public_path__ + "static/img/baihuafang_icon.30e1e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/baihuafang_icon.png
// module id = iiPU
// module chunks = 1